export const VehicleTypes = [
  { label: 'Car', value: 'CAR' },
  { label: 'Commercial', value: 'COMMERCIAL' },
];
